import {Button, ControlGroup, FormGroup, HTMLSelect} from "@blueprintjs/core";
import {observer} from "mobx-react";
import * as React from "react";

import {DocumentBlockType, DocumentType} from "../../../api/values/document-type";
import {useActiveMediaStore} from "../../../stores/active-media-store";
import {handleChangeString} from "../../../utils/handle-change";
import {ValidatedInputText} from "../../molecules/validated-input-text/validated-input-text";
import {SlugEditInput} from "../slug-edit-input/slug-edit-input";
import {TemplateSelector} from "../template-selector/template-selector";
import {DocumentAddStore} from "./document-add-store";

export const DocumentAddBlockDocumentForm: React.FC<{
    store: DocumentAddStore;
    documentType: DocumentType;
    onCreated: () => Promise<unknown>;
}> = observer(({store, documentType, onCreated}) => {
    const hasTemplates = store.templates.length > 0;
    const isFormat = store.blockType === DocumentBlockType.FORMAT;
    const activeMediaId = useActiveMediaStore((state) => state.activeMediaInfo.mediaId);
    return (
        <>
            <FormGroup label="タイトル">
                <ValidatedInputText
                    value={store.title}
                    validationResult={store.titleValidationResult}
                    onChangeValue={(s) => store.setTitle(s)}
                    autoFocus={true}
                />
            </FormGroup>

            <FormGroup label="スラッグ">
                <SlugEditInput store={store.slugEditInputStore} />
            </FormGroup>

            <FormGroup label="種類">
                <ControlGroup>
                    <HTMLSelect
                        value={store.blockType}
                        onChange={handleChangeString((s) => store.setBlockType(s))}
                    >
                        <option value={DocumentBlockType.BLOCK}>ブロック記事</option>
                        <option value={DocumentBlockType.FORMAT}>フォーマットブロック記事</option>
                    </HTMLSelect>
                </ControlGroup>
            </FormGroup>
            {isFormat && (
                <FormGroup
                    label="テンプレート"
                    intent="warning"
                    {...(store.templates.length === 0 && {
                        intent: "danger",
                        helperText: store.validationTemplateMessage,
                    })}
                >
                    {hasTemplates && (
                        <TemplateSelector
                            value={store.templateId}
                            onChange={(item) => store.setTemplateId(item ? item.id.toString() : "")}
                            availableTemplates={store.templates}
                            disabled={!hasTemplates}
                            placeholder="テンプレートを選択"
                            menuMaxHeight={450} // 例: 450px。未指定なら 450px
                            menuMaxWidth={270} // 例: 270px。未指定なら 270px
                        />
                    )}
                </FormGroup>
            )}

            <Button
                disabled={!store.canCreate}
                onClick={() => store.create(documentType, activeMediaId, onCreated)}
            >
                追加
            </Button>
        </>
    );
});
